export default "__VITE_ASSET__fMnCtbo___"